// COOMPONENTS
import Card from "../app/Card";
// PROPS
import { OrderRideProps } from "./order-ride";

export default function GoodsDetails({
  nextDispatchOrderPage,
}: OrderRideProps) {
  return (
    <div>
      <Card header="Goods details">
        <div className="space-y-7">
          <div>
            <label htmlFor="goodsType" className="secondary-text">
              Goods Type
            </label>
            <div className="input-field">
              <select
                required
                className="outline-none w-full secondary-text"
                name=""
                id=""
              >
                <option value="">Perishable</option>
                <option value="">Non-perishable</option>
              </select>
            </div>
          </div>
          <div>
            <label htmlFor="goodsQuantity" className="secondary-text">
              Goods Quantity
            </label>
            <div className="input-field">
              <input
                placeholder="Enter goods quantity"
                type="text"
                name="goodsQuantity"
                required
                className="w-full"
              />
            </div>
          </div>
        </div>
        <div
          className="bg-primary rounded-lg mt-14"
          onClick={nextDispatchOrderPage}
        >
          <button type="submit" className="w-full font-medium">
            Proceed
          </button>
        </div>
      </Card>
    </div>
  );
}
